import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const AccordionItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-l-4 border-[#FCF7EE] bg-[#FCF7EE] p-4 rounded-md shadow-sm py-4">
      <button
        className="flex justify-between items-center w-full text-left"
        onClick={() => setOpen(!open)}
      >
        <span style={{fontFamily:"Fredoka"}} className=" lg:text-[24px] text-[18px] font-semibold text-gray-800">{question}</span>
        {open ? <FaChevronUp /> : <FaChevronDown />}
      </button>
      {open && <p style={{fontFamily:"poppins"}} className="mt-6 lg:text-[20px] text-[15px] text-black">{answer}</p>}
    </div>
  );
};

export default AccordionItem;
